<template>
    <legend>
        <div v-if="!artistMode" class="venue-legend">
            <div v-for="item in legend" :key="item.name" class="items">
                <div
                    v-if="item.name !== 'Cancelled'"
                    class="item-circle"
                    :style="{ 'border-color': item.color }"
                ></div>
                <img v-else src="/images/icons/booked-purple.svg" alt="cancel" />
                <div class="item-name">{{ item.name }}</div>
            </div>
        </div>
        <div v-else class="artist-legend">
            <div v-for="item in artistLegend" :key="item.name" class="items">
                <div
                    v-if="item.name !== 'Cancelled'"
                    class="item-circle"
                    :style="{ 'border-color': item.color }"
                ></div>
                <img v-else src="/images/icons/booked-purple.svg" alt="cancel" />
                <div class="item-name">{{ item.name }}</div>
            </div>
        </div>
    </legend>
</template>

<script>
    export default {
        name: 'BookingLegend',
        props: {
            artistMode: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data: () => ({
            legend: [
                {
                    name: 'Book',
                    color: '#C9CD00'
                },
                {
                    name: 'Advance',
                    color: '#D8B500'
                },
                {
                    name: 'Wrap Up',
                    color: '#D47EBF'
                },
                {
                    name: 'Cancelled',
                    color: ''
                },
                {
                    name: 'Completed',
                    color: '#646464'
                }
            ],
            artistLegend: [
                {
                    name: 'Get Booked',
                    color: '#C9CD00'
                },
                {
                    name: 'Advance',
                    color: '#D8B500'
                },
                {
                    name: 'Wrap Up',
                    color: '#D47EBF'
                },
                {
                    name: 'Cancelled',
                    color: ''
                },
                {
                    name: 'Completed',
                    color: '#646464'
                }
            ]
        })
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .venue-legend,
    .artist-legend {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 50px;
        margin-top: 15px;
    }
    .items {
        display: flex;
        align-items: center;
        gap: 6px;
    }
    .item-circle {
        width: 20px;
        height: 20px;
        border-radius: 100px;
        border: 1.5px solid;
    }
    .item-name {
        color: #646464;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    @media (max-width: 1000px) {
        .venue-legend,
        .artist-legend {
            gap: 12px 12px;
            justify-content: flex-start;
        }
        .items {
            gap: 4px;
        }
        .item-name {
            font-size: 12px;
            font-weight: 650;
            letter-spacing: 0.12px;
        }
        .item-circle {
            width: 16px;
            height: 16px;
        }
    }
</style>
